import Alert from "@pathwright/ui/src/components/alert/Alert"
import Card from "@pathwright/ui/src/components/card/Card"
import { ComponentType } from "react"
import { Redirect } from "react-router-dom"
import useLabFeatureVisibility from "./useLabFeatureVisibility"

// Shared by the Labs index, settings cards, and Home Screen confirmations.
export default function withLabFeatureVisibility<P extends { card: any }>(
  Component: ComponentType<P>,
  feature?: "home" | "coverPages"
) {
  function LabFeatureVisibilityGuard(props: P) {
    const visibility = useLabFeatureVisibility()

    if (visibility.loading) return null
    if (visibility.error) {
      return (
        <Card card={props.card} title="Lab Features">
          <Alert error={visibility.error} />
        </Card>
      )
    }

    // A missing result is not evidence that a feature is unavailable.
    if (visibility.home === null || visibility.coverPages === null) return null

    if (!visibility.hasAvailableLabs) {
      return <Redirect to="/manage/school/features/" />
    }
    if (feature && !visibility[feature]) {
      return <Redirect to="/manage/school/features/lab/" />
    }

    return <Component {...props} />
  }

  return LabFeatureVisibilityGuard
}
